import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './pages/login/login.component';

import { RestService } from './services/rest.service';
import { GlobalvarsService } from './services/globalvars.service';

import { FormsModule } from '@angular/forms';
import { DevicesComponent } from './pages/devices/devices.component';
import { DepartmentsComponent } from './pages/departments/departments.component';
import { UsersComponent } from './pages/users/users.component';
import { ScenariosComponent } from './pages/scenarios/scenarios.component';
import { EditUserComponent } from './pages/users/edit/edit.component';
import { AddUserComponent } from './pages/users/add/add.component';
import { EditDeviceComponent } from './pages/devices/edit/edit.component'
import { AddDeviceComponent } from './pages/devices/add/add.component';
import { AddScenarioComponent } from './pages/scenarios/add/add.component';
import { EditScenarioComponent } from './pages/scenarios/edit/edit.component';
import { AssignDevicesComponent } from './pages/devices/assign/assign.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DevicesComponent,
    DepartmentsComponent,
    UsersComponent,
    ScenariosComponent,
    EditUserComponent,
    AddUserComponent,
    EditDeviceComponent,
    AddDeviceComponent,
    AddScenarioComponent,
    EditScenarioComponent,
    AssignDevicesComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule
  ],
  providers: [
    RestService,
    GlobalvarsService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
